import { call, put } from 'redux-saga/effects';

import { Set } from '~commonInfra/utils/Set';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { requestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';
import { ChangeExtractTaskPriorityAction } from '../../../extractTask/services/ChangeExtractTaskPriorityAction';
import { SetExtractRefreshPriorityAction } from '../../actions/extractRefresh/SetExtractRefreshPriorityAction';

export function* handleSetExtractRefreshPriorityAction(action: SetExtractRefreshPriorityAction) {
  try {
    yield call(executeSetExtractRefreshAction, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeSetExtractRefreshAction(items: IExtractTaskInfo[]) {
  return ChangeExtractTaskPriorityAction.execute(Set.fromIdItemArray(items));
}
